import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { userEntityToModel } from 'shared/domain/user/mapping/toModel';
import { UserModel } from 'shared/domain/user/types/model';
import * as dbUsers from '../../db/users/users';
import * as dbUsersService from '../../db/users/usersService';
import { userContract } from 'shared/domain/user/userContract';
import { makeLoadedEventPublisher, readCollectionPayload } from 'serviceWorker/broadcasts/publishers';

export const broadcastAllUsers = makeLoadedEventPublisher(
  userContract,
  DomainMessagesTypes.allUsers,
  () => readCollectionPayload(dbUsersService, async () => {
    const users = await dbUsers.get();
    return users.map((user) => userEntityToModel(user, users));
  })
);
